import React, { useState, useEffect, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import { InputText } from "../../../../components/Inputs";
import { DeleteIconButton, UpIconButton, DownIconButton } from "../../../../components/Buttons";

const DownloadListItemForm = React.forwardRef(({ className, title: titleProp, text, onMoveUp, onMoveDown, onRemove }, ref) => {
  const [title, setTitle] = useState(titleProp || "");
  const [error, setError] = useState({ title: null });

  useEffect(() => {
    setTitle(titleProp);
  }, [titleProp]);

  useImperativeHandle(ref, () => ({
    getModel: (noValidate) => {
      let isValid = true;
      const newError = { title: null };
      if (!title || title === "") {
        newError.title = true;
        isValid = false;
      }
      if (!noValidate && !isValid) {
        setError(newError);
        return null;
      }
      return { title };
    }
  }), [title]);

  // console.log("DownloadListItemForm.render()", { title, error });
  return (
    <div className={`${className}`}>
      <div className="w3-row neg-margin-lr">
        <div className="w3-col s6 pad-lr">
          <div className={`${error.title ? "error-group" : ""}`}>
            <InputText
              className="w3-block w3-border"
              value={title}
              onChange={(event) => setTitle(event.target.value)}
            />
            {error.title && (<span className="w3-block w3-red">{error.title}</span>)}
          </div>
        </div>
        <div className="w3-col s3 pad">{text}</div>
        <div className="w3-col s3 pad-lr clearfix alg-right-">
          <DeleteIconButton
            className="w3-border w3-right"
            onClick={onRemove}
          />
          <UpIconButton
            className="w3-border"
            onClick={onMoveUp}
            disabled={onMoveUp === null}
          />
          <DownIconButton
            className="w3-border"
            onClick={onMoveDown}
            disabled={onMoveDown === null}
          />
        </div>
      </div>
    </div>
  );
});

DownloadListItemForm.displayName = "DownloadListItemForm";

DownloadListItemForm.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  onMoveUp: PropTypes.func,
  onMoveDown: PropTypes.func,
  onRemove: PropTypes.func,
};

DownloadListItemForm.defaultProps = {
  className: "",
  item: {},
};

export default DownloadListItemForm;
